import React from "react";
import { Dropdown } from 'primereact/dropdown';

const ProSearchableDropDown = ({value, options, onChange, showClear = true})=>{

    const selectedValueTemplate = (option)=>{       
        if (option) {
            return (
                <div className="p-field multiselect-item-value">             
                       <span className="roboto-font" style={{marginLeft:"4px"}}>{option.name}</span>
                </div>
            );
        }

        return "Waitlist";

    }

    return (
        <div className="p-field p-col-12 p-md-12">
        <span className="p-float-label">
            <Dropdown id="searchable_dropdown" className="searchable_dropdown" value={value} options={options} onChange={onChange} optionLabel="name" filter showClear={showClear} filterBy="name" placeholder="Select a Waitlist"
                 valueTemplate={selectedValueTemplate}   />
        {value && <label htmlFor="searchable_dropdown">Waitlist</label> }
        </span>
        </div>
    )

}

export default ProSearchableDropDown;